import React, { useEffect, useState } from "react";
import "./Login.css";
import { Form, Input, Button, Flex, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Mail } from "../../assets/mail.svg";
import { ReactComponent as Password } from "../../assets/pass.svg";
import CryptoJS from "crypto-js";
import { login, sendOtp } from "../../services/ApiService";
import { LoadingOutlined } from "@ant-design/icons";
import { encryptObject } from "../GlobalFunction";

const Login = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  const setSessionData = (data) => {
    const keys = [
      "accessToken",
      "emailId",
      "userType",
      "username",
      "designation",
      "employee_id",
      "id",
    ];
    keys.forEach((key) => sessionStorage.setItem(key, data[key]));
  };

  const onFinish = async (values) => {
    setLoader(true);

    const hashedPassword = CryptoJS.SHA256(values?.password).toString();
    const body = {
      email: values.email,
      password: hashedPassword,
    };

    try {
      const response = await login(body);

      if (response.responseCode === 200) {
        sessionStorage.setItem("emailId", values.email);

        const res = await sendOtp({ email: values.email });
        if (res.responseCode === 200) {
          message.success(res.responseMessage);
          navigate("/verify-email", { state: { text: "OTP Verification" } });
        } else {
          message.error(res.responseMessage);
        }
      } else {
        message.error(response.responseMessage || "Login failed");
      }
    } catch (error) {
      message.error(error.message || "An error occurred during login");
    } finally {
      setLoader(false);
    }
  };

  const handleFormChange = async () => {
    try {
      const values = await form.validateFields();
      setIsFormValid(true);
    } catch (errors) {
      if (errors.errorFields && errors.errorFields.length > 0)
        setIsFormValid(false);
      else setIsFormValid(true);
    }
  };

  const onFinishofForm = () => {
    form
      .validateFields()
      .then((values) => {
        onFinish(values);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  return (
    <>
      <div className="main-container">
        <div>
          <Form
            form={form}
            name="login"
            initialValues={{ remember: true }}
            layout="vertical"
            validateTrigger="onChange"
            style={{ marginTop: "1.3rem" }}
            onValuesChange={handleFormChange}
            onFinish={onFinishofForm}
          >
            <div className="login">
              <h4 className="title">Login</h4>
              <div className="desc">
                Enter your registered email and password
              </div>

              <Form.Item
                name="email"
                label={<span className="input-label">Email</span>}
                rules={[
                  { required: true, message: "Please input your email!" },
                  { type: "email", message: "The input is not a valid email!" },
                ]}
                colon={false}
              >
                <Input
                  className="input"
                  prefix={<Mail style={{ marginRight: "8px" }} />}
                  placeholder="Email address"
                />
              </Form.Item>

              <Form.Item
                name="password"
                label={<span className="input-label">Password</span>}
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
                colon={false}
              >
                <Input.Password
                  prefix={<Password style={{ marginRight: "8px" }} />}
                  placeholder="Password"
                  className="input"
                />
              </Form.Item>

              <div className="forgot-link-wrapper">
                <Link to={"/forgot-password"} className="forgot-pass">
                  Forgot Password?
                </Link>
              </div>
            </div>

            <Flex justify="flex-end" className="login-btn">
              <Button
                htmlType="submit"
                type="primary"
                shape="round"
                disabled={!isFormValid || loader}
                style={{
                  backgroundColor: "#4A3AFF",
                  padding: "1.2rem",
                }}
              >
                Login
                {loader && <LoadingOutlined style={{ color: "white" }} />}
              </Button>
            </Flex>
          </Form>
        </div>

        <div className="copyright">
          Copyright © 2026 Procloz Services Pvt Ltd | All Rights Reserved
        </div>
      </div>
    </>
  );
};

export default Login;
